/** Last known inline nav detail text per section href (survives client nav remounts). */
const rememberedDetailTextByHref = new Map<string, string>();

export function rememberNavDetailText(href: string, text: string): void {
  const trimmed = text.trim();
  if (!trimmed) {
    return;
  }
  rememberedDetailTextByHref.set(href, trimmed);
}

export function getRememberedNavDetailText(href: string): string | null {
  return rememberedDetailTextByHref.get(href) ?? null;
}

export function forgetNavDetailText(href: string): void {
  rememberedDetailTextByHref.delete(href);
}

/** Test-only */
export function clearRememberedNavDetailTextForTests(): void {
  rememberedDetailTextByHref.clear();
}
